import React from "react";
import { Link } from 'react-router-dom';
import appLogo from "../../assets/Flyurdream-logo.png";
import 'remixicon/fonts/remixicon.css';

const Navbar = () => {
  return (
    <div class="header">
      <div class="header-top"></div>
      <div class="container-fluid">
        <div class="container">
          <nav class="navbar navbar-expand-lg navbar-light ">
            <div class="container-fluid">
              <a class="navbar-brand" href="/">
                <img src={appLogo} alt="logo" />
              </a>
              <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                  <li class="nav-item">
                    <a
                      className="nav-link active"
                      aria-current="page"
                      href="/"
                    >
                      Home
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/student">
                      {" "}
                      Students
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/recruitment-partner">
                      {" "}
                      Recruitment Partners
                    </a>
                  </li>
                  {/* <li class="nav-item">
                    <a class="nav-link" href="/institutions-page">
                      Institutions{" "}
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/franchise-page">
                      Franchise{" "}
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" href="/company-page">
                      Company{" "}
                    </a>
                  </li> */}
                  <li class="nav-item">
                    <a class="nav-link ext-link" href="#">
                      Book Demo
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link ext-link" href="#">
                      Login
                    </a>
                  </li>
                </ul>
                <ul class="nav-ext-item">
                  <li class="nav-item">
                    <a class="nav-link ext-link" href="#">
                      Book Demo
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link ext-link"
                      href="https://crm.flyurdream.com/"
                    >
                      Login
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
